import * as React from 'react'
import type { ENTITY_TYPES } from '@sales-center/common'
import { CancelAppointmentWrapper } from './CancelAppointmentFormWrapper'
import { CancelAppointmentSubHeader, CircularProgress } from '../../atoms'
import { useGetCancelReasonsOnMount } from '@user/store/scheduling'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import { useTheme } from '@mui/material/styles'

interface Props {
  onClose: () => void
  onCloseMain: () => void
  appointmentId?: string
  open: boolean
  submitCallback?: () => void
  entityId: number
  entityType: ENTITY_TYPES
}

export function CancelAppointmentDialog(props: Props) {
  const { open, onClose } = props

  const loading = useGetCancelReasonsOnMount(open)
  const theme = useTheme()
  return loading === 'pending' ? (
    <Box height="80px" display="flex">
      <CircularProgress color="primary" />
    </Box>
  ) : loading === 'fail' ? (
    <Box>
      <Box p={1} width="100%">
        <Alert severity="error">Unable to load Cancel Reasons</Alert>
      </Box>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          CLOSE
        </Button>
      </DialogActions>
    </Box>
  ) : (
    <>
      <DialogTitle>Cancel Appointment</DialogTitle>
      <DialogContent
        dividers
        style={{ border: 'none', paddingTop: theme.spacing(1) }}
      >
        <CancelAppointmentSubHeader>
          Select a reason for cancelling appointment
        </CancelAppointmentSubHeader>
        <CancelAppointmentWrapper {...props} />
      </DialogContent>
    </>
  )
}
